import { transitionDigitalSavingsDocumentsForm } from '../../../actions/digitalSavings/Documents';
import { getDocumentsForm } from '../../../selectors/digitalSavings/documents';
import { getIdPassportValue } from '../../../selectors/digitalSavings/personalDetails';

import { FIELD_STATUS } from '../../../reducers/status';

export const documentsFormRules = (store, next, action) => {
    const result = next(action);
    const documentsForm = getDocumentsForm(store.getState());
    const idPassport = getIdPassportValue(store.getState());
    const documentsFormValid = validateDocumentsFormDetails(documentsForm,idPassport);
    const formAction = documentsFormValid
        ? transitionDigitalSavingsDocumentsForm.formValid()
        : transitionDigitalSavingsDocumentsForm.formInvalid();
    store.dispatch(formAction);
    return result;
};

const validateDocumentsFormDetails = (formFields,idPassport) => {
    if(idPassport.value === 'passport') {
        return (
            formFields.passportUpload &&
            formFields.passportUpload.status === FIELD_STATUS.VALID &&
            formFields.kraPinUpload &&
            formFields.kraPinUpload.status === FIELD_STATUS.VALID
        );
    } else {
        return (
            formFields.idUpload &&
            formFields.idUpload.status === FIELD_STATUS.VALID &&
            formFields.kraPinUpload &&
            formFields.kraPinUpload.status === FIELD_STATUS.VALID
        );
    }
};
